import { combineReducers } from 'redux';
import languagesSlice from './languages-slice';
import productsSlice from './seller-center/products-slice/index.js';
import ordersSlice from './seller-center/orders-slice/index.js';
import shipmentsSlice from './seller-center/shipments-slice';
import usersSlice from './seller-center/users-slice';
import reviewsSlice from './seller-center/reviews-slice/index.js';
import quickLinksSlice from './quick-links-slice/index.js';
import userinfoSlice from './seller-center/userinfo-slice/index.js';
import notificationsSlice from './seller-center/notifications-slice/index.js';
import tenantSlice from './tenant-slice/index.js';
import settlementsSlice from './seller-center/settlements-slice';
import sellersSlice from './cp/sellers-slice';
import cpReviewsSlice from './cp/reviews-slice/index.js';
import userSlice from './cp/user-slice/index.js';
import cpOrdersSlice from './cp/orders-slice/index.js';
import cpSettlementsSlice from './cp/settlements-slice';
import transactionsSlice from './seller-center/transactions-slice';

const reducers = combineReducers({
  tenantData: tenantSlice,
  languageData: languagesSlice,
  productsData: productsSlice,
  ordersData: ordersSlice,
  shipmentsData: shipmentsSlice,
  usersData: usersSlice,
  reviewsData: reviewsSlice,
  quickLinksData: quickLinksSlice,
  userData: userinfoSlice,
  notificationsData: notificationsSlice,
  settlementsData: settlementsSlice,
  sellersData: sellersSlice,
  cpReviewsData: cpReviewsSlice,
  cpUserData: userSlice,
  cpOrdersData: cpOrdersSlice,
  cpSettlementsData: cpSettlementsSlice,
  transactionsData: transactionsSlice,
});

export default reducers;
